import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-callbacks',
  templateUrl: './callbacks.component.html'
})
export class CallbacksComponent implements OnInit {

  @Input() callbacks : any;
  constructor() { }

  ngOnInit(): void {
  }

}
